import React from 'react';
import SingleTestimonial from './SingleTestimonial';
import TestimonialOne from "../images/testimonialOne.png";
import TestimonialTwo from "../images/testimonialTwo.png";
import TestimonialThree from "../images/testimonialThree.png";


export default function Testimonials() {
    return (
        <div className="row section-5-about-page mt-5 mb-2 pt-1">
            <div className="col-12 px-0 testimonials">
                <div className="row m-0 mb-4 p-0 testimonials-heading">
                    <h2 className='fw-normal text-center'>Testimonials</h2>
                    <hr className='underline-design mx-auto' />
                </div>
                <div className="row m-0 p-0 testimonials-row px-3 gap-lg-3 gap-1">
                    <SingleTestimonial 
                        testText="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo"
                        testAuthorImg={TestimonialOne}
                        testAuthorName="Patricia Warren"
                    />
                    <SingleTestimonial 
                        testText="Convallis lacinia optio! Hac morbi laboris deleniti, hymenaeos, nihil, magnis corrupti nisl dis dolores aptent eveniet nostrud eu"
                        testAuthorImg={TestimonialTwo}
                        testAuthorName="Lauren Lane"
                    />
                    <SingleTestimonial 
                        testText="Semper laboris possimus, molestiae, anim ornare? Molestie! Dictumst scelerisque error, autem leo. Autem integer diamlorem"
                        testAuthorImg={TestimonialThree}
                        testAuthorName="Paul Smitten"
                    />
                </div>
            </div>
        </div>
    )
}
